import React, { useEffect, useState } from 'react';
import Slab from '../../../../helpers/slab/Slab';
import Details from './Details';
import Summary from './Summary';
import Files from '../../../creates/file/Files';
import Audit from '../../generic/Audit';
import Get from '../../../../api/internal/Get';
import MaintenanceLogs from '../MaintenanceLogs';
import AssetTracking from '../AssetTracking';
import Admin from '../Admin';
import { ADMIN_AUTHORIZED_ROLES } from '../../../../auth/AuthRoles';
import { useRoleAuthorization } from '../../../../hooks/useRoleAuthorization';

function Trailer({
  assetId,
  trailerName,
  startPage,
}: {
  assetId: number;
  trailerName: string;
  startPage?: string;
}) {
  const [currentPage, setCurrentPage] = useState();
  const [trailerDataObject] = useState<TrailerDataObject>({
    Audit: null,
    Admin: null,
    Details: null,
    Files: null,
    'Maintenance Logs': null,
    Summary: null,
    Tracking: null,
  });

  useEffect(() => {
    startPage ? HandlePageChange(startPage) : HandlePageChange('Summary');
  }, []);

  function HandlePageChange(params) {
    if (!trailerDataObject[params] && pages[params].callerPath) {
      Get(pages[params].callerPath).then(response => {
        if (response) {
          trailerDataObject[params] = response.data;
        }
        AssignPages();
        setCurrentPage(params);
      });
    } else {
      setCurrentPage(params);
    }
  }

  function RefreshPage(currentPage: string, additionalPages: string[]) {
    setCurrentPage(null);
    trailerDataObject[currentPage] = null;
    additionalPages?.forEach(pageName => {
      trailerDataObject[pageName] = null;
    });
    HandlePageChange(currentPage);
  }

  let pages = {};
  AssignPages();
  function AssignPages() {
    pages = {
      Summary: {
        content: (
          <Summary
            HandlePageChange={HandlePageChange}
            data={trailerDataObject?.Summary}
          />
        ),
        callerPath: `/Asset/GetTrailerSummary/${assetId}`,
      },
      Details: {
        content: (
          <Details
            data={trailerDataObject?.Details}
            assetId={assetId}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Asset/GetTrailerDetails/${assetId}`,
      },
      'Maintenance Logs': {
        content: (
          <MaintenanceLogs data={trailerDataObject['Maintenance Logs']} />
        ),
        callerPath: `/Asset/GetMaintenanceLogForAssetPanel/${assetId}`,
      },
      Files: {
        content: (
          <Files
            data={trailerDataObject?.Files}
            fileCategory={'asset'}
            categoryId={assetId}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/File/GetAllFiles/asset-${assetId}`,
      },
      Audit: {
        content: <Audit data={trailerDataObject?.Audit} />,
        callerPath: `/Asset/GetAssetAudit/${assetId}`,
      },
      Tracking: {
        content: (
          <AssetTracking
            data={trailerDataObject.Tracking}
            assetId={assetId}
            loadId={null}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Asset/GetAllLocationsForAsset/${assetId}`,
      },
    };
    if (useRoleAuthorization(ADMIN_AUTHORIZED_ROLES))
      pages['Admin'] = {
        content: (
          <Admin
            data={trailerDataObject.Admin}
            assetId={assetId}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Asset/GetAssetAdmin/${assetId}`,
      };
  }

  return (
    <Slab
      title={'Trailer: ' + trailerName}
      pages={pages}
      currentPage={currentPage}
      HandlePageChange={HandlePageChange}
      dataObject={trailerDataObject}
    />
  );
}
export default Trailer;
